export default {
  ui: {
    colors: {
      primary: 'green',
      neutral: 'slate',
      brown: 'clay'
    }
  }
}
